<template>
  <Splide
    :options="options"
    :extensions="extensions"
    id="carousel-container"
    @splide:move="stopVideoOnSwipe()"
  >
    <SplideSlide
      v-for="profile in videoProfiles"
      :key="profile.id"
      class="carousel__item"
      @click="selected = true"
      :data-splide-youtube="
        isYouTube(profile.videoFull)
          ? normalizeYouTube(profile.videoFull)
          : null
      "
      :data-splide-vimeo="
        isVimeo(profile.videoFull) ? normalizeVimeo(profile.videoFull) : null
      "
    >
      <img :src="profile.poster" loading="lazy" :alt="profile.name" />
      <div
        v-if="selected != true"
        class="video-caption"
        :class="profile.name.replace(/\s+/g, '')"
      >
        <h3>{{ profile.name }}</h3>
        <p>{{ profile.description }}</p>
      </div>
    </SplideSlide>
  </Splide>
</template>

<script>
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import { Video } from "@splidejs/splide-extension-video";
import { defineComponent } from "vue";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";

import "@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css";

export default defineComponent({
  name: "VideoExample",

  components: {
    Splide,
    SplideSlide,
  },

  setup() {
    const options = { rewind: true };

    // helpers must be defined...
    const isYouTube = (url) => /youtube\.com|youtu\.be/.test(url);
    const isVimeo = (url) => /vimeo\.com/.test(url);

    const normalizeYouTube = (url) => {
      // Accept Shorts, watch, youtu.be; return the ID
      const shorts = url.match(/shorts\/([a-zA-Z0-9_-]{6,})/);
      const watch = url.match(/[?&]v=([a-zA-Z0-9_-]{6,})/);
      const short = url.match(/youtu\.be\/([a-zA-Z0-9_-]{6,})/);
      return (
        (shorts && shorts[1]) ||
        (watch && watch[1]) ||
        (short && short[1]) ||
        url
      );
    };

    const normalizeVimeo = (url) => {
      const m = url.match(/vimeo\.com\/(\d+)/);
      return m ? m[1] : url;
    };

    // ...and returned so the template can use them
    return {
      options,
      extensions: { Video },
      isYouTube,
      isVimeo,
      normalizeYouTube,
      normalizeVimeo,
    };
  },

  data() {
    return {
      selected: undefined,

      videoProfiles: [
        {
          id: 1,
          hover: true,
          buttonHover: false,
          fullVideo: false,
          firstVideo: true,
          poster:
            "https://tcnj.edu/custom/homepage/img/rollover-stills/9-16-25/final/aashmi2.jpg",
          name: "Aashmi Matthew",
          caption:
            "https://tcnj.edu/custom/homepage/captions/9-16-25/aashmi.vtt",
          description:
            "At TCNJ, Aashmi found the “just-right” balance of big-school spirit and close-knit community she wanted.",
          // videoFull: "https://vimeo.com/1118745063",
          videoFull: "https://youtube.com/shorts/tKy651bW09I",
        },
        {
          id: 2,
          hover: false,
          buttonHover: false,
          fullVideo: false,

          poster:
            "https://tcnj.edu/custom/homepage/img/rollover-stills/9-16-25/final/jp2.jpg",
          name: "JP Egan",
          caption: "https://tcnj.edu/custom/homepage/captions/9-16-25/jp.vtt",
          description:
            "As a fraternity founder and student government leader, JP credits student organizations for helping him to grow and thrive.",
          videoFull: "https://youtube.com/shorts/tgYktqANrl8?feature=share",
        },
        {
          id: 3,
          hover: false,
          buttonHover: false,
          fullVideo: false,
          poster:
            "https://tcnj.edu/custom/homepage/img/rollover-stills/9-16-25/final/grace2.jpg",
          name: "Grace McHugh",
          caption:
            "https://tcnj.edu/custom/homepage/captions/9-16-25/grace.vtt",
          description:
            "Grace shaped her studies — and her future — with guidance from passionate, supportive professors. ",
          videoFull: "https://youtube.com/shorts/hIY_llOkVnU?feature=share",
        },
      ],
    };
  },
  methods: {
    stopVideoOnSwipe() {
      // console.log("swipe");
      // videoProfiles.fullVideo = false;
      this.selected = undefined;
      // profile.fullVideo = false;

      // profile.fullVideo = false;
    },
  },
});
</script>
